export default "__VITE_ASSET__B8F69o6j__"